import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[color:var(--marupiara-obsidian)]">
        <div className="text-[color:var(--marupiara-gold)] font-serif text-2xl">Carregando…</div>
      </div>
    );
  }
  if (!user || user === false || user.role !== "admin") {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}
